import { createContext, useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { partnerGetProfile, clearPartnerSession } from "../services/partnerCalls";
import { errorHandler } from "../utils";
import { DEFAULT_ERROR_MESSAGE } from "../constants";

export const PartnerContext = createContext(undefined);

export const PartnerContextProvider = ({ children }) => {
  const navigate = useNavigate();
  const [profileData, setProfileData] = useState(null);
  const [loading, setLoading] = useState(false);

  const fetchPartnerProfile = async () => {
    setLoading(true);
    try {
      const res = await partnerGetProfile();
      if (res?.data?.data) {
        setProfileData(res.data.data);
      }
    } catch (error) {
      // A stale/expired/invalid partner token — clear it and send them back
      // to sign-in rather than leaving a half-loaded shell up.
      if (error?.response?.status === 401) {
        clearPartnerSession();
        navigate("/partner-login", { replace: true });
        return;
      }
      if (error?.response?.data?.message) {
        errorHandler(error?.response?.data?.message || DEFAULT_ERROR_MESSAGE);
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPartnerProfile();
  }, []);

  return (
    <PartnerContext.Provider
      value={{
        profileData,
        setProfileData,
        loading,
        fetchPartnerProfile,
      }}
    >
      {children}
    </PartnerContext.Provider>
  );
};

export const usePartnerContext = () => {
  const context = useContext(PartnerContext);
  if (context === undefined) {
    throw new Error(
      "usePartnerContext must be used within a PartnerContextProvider"
    );
  }
  return context;
};
